import { render, staticRenderFns } from "./can-you-name-the-psychological-disorder.vue?vue&type=template&id=6cb2f526&scoped=true&"
import script from "./can-you-name-the-psychological-disorder.vue?vue&type=script&lang=js&"
export * from "./can-you-name-the-psychological-disorder.vue?vue&type=script&lang=js&"
import style0 from "./can-you-name-the-psychological-disorder.vue?vue&type=style&index=0&id=6cb2f526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2f526",
  null
  
)

export default component.exports